import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import IconButton from 'material-ui/IconButton';
import LeftIcon from 'material-ui-icons/ChevronLeft';
import RightIcon from 'material-ui-icons/ChevronRight';

class PrevNextButtons extends Component {

  onPrevious(data) {

    let access_id = data["access id"];

    if (this.props.saved_search_data.length > 0){

      let ids = [];
      for (var i = 0; i < this.props.saved_search_data.length; i++){
        ids.push(this.props.saved_search_data[i]["access id"]);
      }

      let index = ids.indexOf(access_id);
      let prev_candidate = this.props.saved_search_data[index-1];

      if (index - 1 < 0) {
        alert("This is the furthest back you can go.")
      } else {
        let new_access_id = prev_candidate["access id"];
        this.props.changeRoute('/console/user/'+new_access_id)
      }

    } else {

      let ids = [];
      for (var i = 0; i < this.props.rrd_data.length; i++){
        ids.push(this.props.rrd_data[i]["access id"]);
      }

      let index = ids.indexOf(access_id);
      let prev_candidate = this.props.rrd_data[index-1];

      if (index - 1 < 0) {
        alert("This is the furthest back you can go.")
      } else {
        let new_access_id = prev_candidate["access id"];
        this.props.changeRoute('/console/user/'+new_access_id)
      }
    }
  }

  onNext(data) {

    let access_id = data["access id"];

    if (this.props.saved_search_data.length > 0){

      let ids = [];
      for (var i = 0; i < this.props.saved_search_data.length; i++){
        ids.push(this.props.saved_search_data[i]["access id"]);
      }

      let index = ids.indexOf(access_id);
      let next_candidate = this.props.saved_search_data[index+1];

      if (index + 1 >= this.props.saved_search_data.length) {
        alert("No more candidates to display.")
      } else {
        let new_access_id = next_candidate["access id"];
        this.props.changeRoute('/console/user/'+new_access_id)
      }
    } else {

      let ids = [];
      for (var i = 0; i < this.props.rrd_data.length; i++){
        ids.push(this.props.rrd_data[i]["access id"]);
      }

      let index = ids.indexOf(access_id);
      let next_candidate = this.props.rrd_data[index+1];

      if (index + 1 >= this.props.rrd_data.length) {
        alert("No more candidates to display.")
      } else {
        let new_access_id = next_candidate["access id"];
        this.props.changeRoute('/console/user/'+new_access_id)
      }
    }
  }

  render(){
    const { classes, theme, location, data } = this.props;
    return(
      <div className={classes.root}>
        <IconButton className={classes.leftButton}>
          <LeftIcon className={classes.icon} onClick={() => this.onPrevious(data)}/>
        </IconButton>
        <IconButton className={classes.rightButton} onClick={() => this.onNext(data)}>
          <RightIcon className={classes.icon}/>
        </IconButton>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        rrd_data: state.rrd_data,
        saved_search_data: state.savedSearchData,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps,mapDispatchToProps)(PrevNextButtons)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/User/scenes/Core/components/PrevNextButtons/index.js